import { useMemo } from "react";

import { useSelector } from "react-redux";

import { selectAllLimits } from "./selectors";

export const useLimits = () => useSelector(selectAllLimits);

export const useMaximumAvailablePushAmount = () => {
  // Returns the maximum total limit amount. NOT limit remaining.
  const limits = useLimits();
  return useMemo(() => {
    const minimums = Object.keys(limits).map((transactionType) => {
      // Only consider limits relevant to the transfer flow
      if (
        !["ach_push", "immediate_ach_push", "fednow_send"].includes(
          transactionType,
        )
      ) {
        return 0;
      }
      if (limits[transactionType as API.Limits.Type]) {
        let categoryMin: number = Infinity;
        Object.entries(
          limits[transactionType as API.Limits.Type] || {},
        ).forEach(([key, val]) => {
          if (key === "amount_available") {
            return;
          }
          if ((val as API.Limits.Info).amount < categoryMin) {
            categoryMin = (val as API.Limits.Info).amount;
          }
        });
        return categoryMin;
      }
      return 0;
    });
    return minimums.length > 0 ? Math.max(...minimums) : Infinity;
  }, [limits]);
};

export const useMaximumAvailablePullAmount = () => {
  const limits = useLimits();
  return useMemo(() => {
    let categoryMin: number = Infinity;
    Object.entries(limits.ach_pull || {}).forEach(([key, val]) => {
      if (key === "amount_available") {
        return;
      }
      if ((val as API.Limits.Info).amount < categoryMin) {
        categoryMin = (val as API.Limits.Info).amount;
      }
    });
    return categoryMin;
  }, [limits]);
};
